import { FETCH_SYSTEM_OVERVIEW_SUCCESS } from '../modules/system';

const translateSystemOverviewResponse = store => next => action => {
  // we only want to translation the fetch user success action payload
  if (action.type !== FETCH_SYSTEM_OVERVIEW_SUCCESS) {
    return next(action);
  }

  // If nothing was returned, do not continue with shaping data
  if (!action.payload[0]) {
    throw new Error('Get system overview returned no data');
  }

  const sites = action.payload
    .map(site => {
      // if no site data was returned, log it and continue
      if (!site.data || !site.data.site) {
        // Defined globally at window scope in main app index.js
        // eslint-disable-next-line
        Rollbar.warn('Response from get system overview returned an empty site', {
          prospectId: site.prospectId,
        });
        return null;
      }

      const { systemsCharacteristics, battery, inverter, alerts, ...system } = site.data.site;
      let systemsCharacteristicsNode = {};
      const panels = [];
      const batteries = [];
      const inverters = [];
      const systemAlerts = [];

      // If there wasn't a node returned, we don't want this to error
      if (systemsCharacteristics.edges && systemsCharacteristics.edges.length > 0) {
        systemsCharacteristicsNode = systemsCharacteristics.edges[0].node;

        systemsCharacteristics.edges.forEach(edge => {
          panels.push({
            numPanels: edge.node.numPanels,
            model: edge.node.panelModel,
            manufacturer: edge.node.panelMfg,
          });
        });
      }
      if (battery.edges && battery.edges.length > 0) {
        battery.edges.forEach(edge => {
          batteries.push({
            manufacturer: edge.node.manufacturer,
            model: edge.node.model,
            name: edge.node.name,
            serialNumber: edge.node.serialNumber,
          });
        });
      }
      if (inverter.edges && inverter.edges.length > 0) {
        inverter.edges.forEach(edge => {
          inverters.push({
            manufacturer: edge.node.manufacturer,
            model: edge.node.model,
            name: edge.node.name,
            serialNumber: edge.node.serialNumber,
          });
        });
      }

      if (alerts && alerts.edges && alerts.edges.length > 0) {
        alerts.edges.forEach(edge => {
          systemAlerts.push({
            openDate: edge.node.openDateUTC,
            status: edge.node.customerFriendlyStatus,
          });
        });
      }

      return {
        ...systemsCharacteristicsNode,
        ...system,
        systemSize: site.data.site.systemSizeDC,
        batteries,
        inverters,
        panels,
        pgThreshold: site.data.pgThreshold,
        systemAlerts,
        prospectId: site.prospectId,
      };
    })
    .filter(site => !!site);

  if (sites.length === 0) {
    throw new Error('Get system overview returned a payload but no valid sites');
  }

  // We cannot take the first site in the array - there is a chance the user had logged in before
  // and ended their session with a different prospect selected. In this scenario if we default here,
  // we could potentially display the WRONG system info for the account they have selected
  const userProspectId = store?.getState().user?.get('prospectId');
  let siteToDefault = sites[0];

  if (userProspectId && sites.filter(site => site?.prospectId === userProspectId).length > 0) {
    [siteToDefault] = sites.filter(site => site?.prospectId === userProspectId);
  }
  const newAction = {
    type: action.type,
    payload: {
      agreementNumber: siteToDefault.agreementNumber,
      systemSize: siteToDefault.systemSizeDC,
      timezone: siteToDefault.tzName,
      welcomeDate: siteToDefault.welcomeDate, // 2011-06-15, 2016-07-01
      inverterMfg: siteToDefault.inverterMfg,
      inverterModel: siteToDefault.inverterModel,
      numInverters: siteToDefault.numInverters,
      numPanels: siteToDefault.numPanels,
      panelMfg: siteToDefault.panelMfg,
      panelModel: siteToDefault.panelModel,
      serviceContractName: siteToDefault.serviceContractName,
      status: siteToDefault.status,
      systemAlerts: siteToDefault.systemAlerts,
      prospectId: siteToDefault.prospectId,
      inverters: siteToDefault.inverters,
      batteries: siteToDefault.batteries,
      panels: siteToDefault.panels,
      allSites: sites,
      pgThreshold: siteToDefault.pgThreshold,
    },
  };
  return next(newAction);
};

export default translateSystemOverviewResponse;
